<div
  *transloco="let t"
  #sectionId_webinar
  id="sectionId_webinar"
  class="rowBackgroundRed sectionId_webinar sectionAnchor flexBoxOuter dont-hide-circle"
  style="padding: 50px 20px; background: #bb7c7a"
>
  <div class="flexBoxInner txt marginRight" style="hyphens: auto">
    <div class="rowBackgroundRed" style="margin-bottom: 50px">
      <div style="display: inline">
        <h3
          class="kennwertered"
          style="
            font-weight: bold;
            color: white;
            display: inline-block;
            margin-right: 0;
            margin-top: 0;
            margin-bottom: 0;
          "
          data-translate="webinar.header"
        >
          {{ t("products.webinar.header") }}
        </h3>
      </div>
      <div class="newsBox">
        <ul style="list-style-type: none">
          @if (getUpcoming(webinars).length === 0) {
            <li style="color: white; padding-top: 10px; width: 100%">
              <span>
                {{ t("products.webinar.comingsoon") }}
              </span>
            </li>
          } @else {
            @for (webinar of getUpcoming(webinars, 3); track webinar.date) {
              <li style="color: white; padding-top: 10px; width: 100%">
                <div style="width: 69%; display: inline-flex">
                  <span>{{ t("products.webinar." + webinar.alias) }} {{ webinar.date }}</span>
                </div>
                <a
                  class="btn btn-elegant-white newsBoxButton"
                  [class.disabled]="isDateInPast(webinar.date)"
                  rel="noopener"
                  target="_blank"
                  [attr.href]="isDateInPast(webinar.date) ? null : webinar.url"
                  (click)="isDateInPast(webinar.date) ? $event.preventDefault() : null"
                  style="vertical-align: baseline"
                >
                  <span class="newsBoxButtonText">{{ t("products.webinar.more-info") }}</span>
                  <span class="newsBoxButtonText2">{{ t("products.webinar.info") }}</span>
                </a>
              </li>
            }
          }
        </ul>
      </div>
    </div>
    @if (getUpcoming(events).length > 0) {
      <div class="rowBackgroundRed" style="margin-bottom: 50px">
        <div style="display: inline">
          <h3
            class="kennwertered"
            style="
              font-weight: bold;
              color: white;
              display: inline-block;
              margin-right: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            {{ t("products.events.header") }}
          </h3>
        </div>
        <div class="newsBox">
          <ul style="list-style-type: none">
            @for (events of getUpcoming(events); track events.date) {
              <li style="color: white; padding-top: 10px; width: 100%">
                <div style="width: 69%; display: inline-flex">
                  <span style="font-weight: bold">{{ events.title }}</span>
                </div>
                <div style="width: 69%; display: inline-flex; margin-left: 22px">
                  <span
                    >{{ events.description }}
                    @if (events.videoLink) {
                      (<a
                        [href]="events.videoLink"
                        target="_blank"
                        rel="noopener"
                        style="color: white; text-decoration: none"
                        ><mat-icon class="material-symbols-outlined" style="font-size: 20px; vertical-align: middle">
                          play_arrow
                        </mat-icon>
                        Vidéo</a
                      >
                      )
                    }
                  </span>
                </div>
                <a
                  class="btn btn-elegant-white newsBoxButton"
                  [class.disabled]="isDateInPast(events.date)"
                  rel="noopener"
                  target="_blank"
                  [attr.href]="isDateInPast(events.date) ? null : events.url"
                  (click)="isDateInPast(events.date) ? $event.preventDefault() : null"
                  style="vertical-align: baseline"
                >
                  <span>{{ t("products.webinar.info") }}</span>
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    @if (getNews().length > 0) {
      <div class="rowBackgroundRed" style="margin-bottom: 10px">
        <div style="display: inline">
          <h3
            class="kennwertered"
            style="
              font-weight: bold;
              color: white;
              display: inline-block;
              margin-right: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            {{ t("products.news.header") }}
          </h3>
        </div>
        <div class="newsBox">
          <ul style="list-style-type: none">
            @for (news of getNews(); track news.id) {
              <li style="color: white; padding-top: 10px; width: 100%">
                <div style="width: 69%; display: inline-flex">
                  <span>{{ t("products.news.news-" + news.id) }}</span>
                </div>
                <a
                  class="btn btn-elegant-white newsBoxButton"
                  rel="noopener"
                  target="_blank"
                  [href]="news.url"
                  style="vertical-align: baseline"
                >
                  <span class="newsBoxButtonText">{{ t("products.news.news-" + news.id + "-button") }}</span>
                  <span class="newsBoxButtonText2">{{ t("products.news.news-" + news.id + "-button") }}</span>
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  </div>

  <div class="flexBoxInner img">
    <!--   einsparung durch CO2     -->
    <div class="centerImage centerImgVertically" style="position: relative; text-align: center">
      <a ng-cloak class="swissbau" (click)="openCO2Pdf($event)" target="_blank">
        <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
          <style>
            circle {
              fill: white;
              fill-opacity: 0.1;
              stroke: white;
              stroke-width: 2px;
            }
          </style>
          <circle class="white-hover-bg" cx="250" cy="250.4" r="241.6" />
        </svg>
        <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
          <span class="co2-1">CO<sub>2</sub></span
          ><br /><span class="swissbau1-1" data-translate="show.co2-2">{{ t("products.show.co2-2") }}</span
          ><br /><span class="co2-3" data-translate="show.co2-3">{{ t("products.show.co2-3") }}</span>
        </span>
      </a>
    </div>
  </div>
</div>
